import React from 'react';
import * as FiIcons from 'react-icons/fi';

// Create a wrapper for each icon component to fix the TS error
// The issue is that ReactNode is returned but React expects JSX.Element for components
type IconProps = {
  size?: number;
  className?: string;
  color?: string;
  [key: string]: any;
};

const createIconComponent = (Icon: any) => {
  return function IconWrapper({ size, className, color, ...props }: IconProps) {
    return React.createElement(Icon, { size, className, color, ...props });
  };
};

// Export all Feather icons with fixed types
export const FiTwitter = createIconComponent(FiIcons.FiTwitter);
export const FiLinkedin = createIconComponent(FiIcons.FiLinkedin);
export const FiInstagram = createIconComponent(FiIcons.FiInstagram);
export const FiGithub = createIconComponent(FiIcons.FiGithub);
export const FiHome = createIconComponent(FiIcons.FiHome);
export const FiDollarSign = createIconComponent(FiIcons.FiDollarSign);
export const FiMessageSquare = createIconComponent(FiIcons.FiMessageSquare);
export const FiUser = createIconComponent(FiIcons.FiUser);
export const FiBookmark = createIconComponent(FiIcons.FiBookmark);
export const FiSettings = createIconComponent(FiIcons.FiSettings);
export const FiLogOut = createIconComponent(FiIcons.FiLogOut);
export const FiSun = createIconComponent(FiIcons.FiSun);
export const FiMoon = createIconComponent(FiIcons.FiMoon);
export const FiInfo = createIconComponent(FiIcons.FiInfo);
export const FiCreditCard = createIconComponent(FiIcons.FiCreditCard);
export const FiUsers = createIconComponent(FiIcons.FiUsers);
export const FiArrowLeft = createIconComponent(FiIcons.FiArrowLeft);
export const FiSend = createIconComponent(FiIcons.FiSend);
export const FiArrowRight = createIconComponent(FiIcons.FiArrowRight);
export const FiArrowUp = createIconComponent(FiIcons.FiArrowUp);
export const FiArrowDown = createIconComponent(FiIcons.FiArrowDown);
export const FiTrendingUp = createIconComponent(FiIcons.FiTrendingUp);
export const FiPieChart = createIconComponent(FiIcons.FiPieChart);
export const FiCalendar = createIconComponent(FiIcons.FiCalendar);
export const FiShield = createIconComponent(FiIcons.FiShield);
export const FiClock = createIconComponent(FiIcons.FiClock);
export const FiPlayCircle = createIconComponent(FiIcons.FiPlayCircle);
export const FiUserCheck = createIconComponent(FiIcons.FiUserCheck);
export const FiMail = createIconComponent(FiIcons.FiMail);
export const FiLock = createIconComponent(FiIcons.FiLock);
export const FiEyeOff = createIconComponent(FiIcons.FiEyeOff);
export const FiEye = createIconComponent(FiIcons.FiEye);
export const FiPaperclip = createIconComponent(FiIcons.FiPaperclip);
export const FiActivity = createIconComponent(FiIcons.FiActivity);
export const FiTarget = createIconComponent(FiIcons.FiTarget);
export const FiBell = createIconComponent(FiIcons.FiBell);
export const FiBarChart2 = createIconComponent(FiIcons.FiBarChart2);
export const FiAlertTriangle = createIconComponent(FiIcons.FiAlertTriangle);
export const FiCheckCircle = createIconComponent(FiIcons.FiCheckCircle);
export const FiSliders = createIconComponent(FiIcons.FiSliders);
export const FiMenu = createIconComponent(FiIcons.FiMenu);
export const FiX = createIconComponent(FiIcons.FiX);
export const FiDownload = createIconComponent(FiIcons.FiDownload); 
export const FiPlus = createIconComponent(FiIcons.FiPlus);
export const FiEdit = createIconComponent(FiIcons.FiEdit);
export const FiTrash2 = createIconComponent(FiIcons.FiTrash2);
export const FiAlertCircle = createIconComponent(FiIcons.FiAlertCircle);

export const FiPhone = createIconComponent(FiIcons.FiPhone);
export const FiKey = createIconComponent(FiIcons.FiKey);

export const FiMonitor = createIconComponent(FiIcons.FiMonitor);
